import PropTypes from 'prop-types';

export const customGroupPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  customGroupName: PropTypes.string.isRequired,
  publicFlag: PropTypes.string.isRequired,
  archivalFlag: PropTypes.bool.isRequired,
  sftpDeliveryFlag: PropTypes.bool.isRequired,
  allowEditFlag: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  })),
  createdBy: PropTypes.string,
  updatedBy: PropTypes.string,
  itemsString: PropTypes.string,
});

export const CustomGroupDiscardChangesModalDataPropTypes = PropTypes.shape({
  show: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    selectedCustomGroupId: PropTypes.number.isRequired,
  }),
}).isRequired;


export const OptionPropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

export const OptionsPropTypes = PropTypes.arrayOf(OptionPropTypes).isRequired;

export const OptionsForAllCustomGroupTypes = PropTypes.shape({
  CG: OptionsPropTypes,
  BR: OptionsPropTypes,
});
